import React from 'react';
import { Link } from 'react-router-dom';

export default function FundSuccess({ lastFundedAmount }) {
  const amount = parseFloat(lastFundedAmount) || 0;

  return (
    <div
      style={{
        maxWidth: 600,
        margin: '50px auto',
        padding: 24,
        textAlign: 'center',
        background: '#111',
        color: '#fff',
        borderRadius: 12,
        boxShadow: '0 0 20px rgba(255, 215, 0, 0.3)',
      }}
    >
      <h2 style={{ color: '#ffd700', marginBottom: 16 }}>Funding Successful!</h2>
      <p style={{ fontSize: 18, marginBottom: 32 }}>
        You have successfully funded your account with{' '}
        <strong>${amount.toLocaleString()}</strong>
      </p>
      <Link
        to="/"
        style={{
          display: 'inline-block',
          padding: '10px 24px',
          background: '#ffd700',
          color: '#000',
          fontWeight: 'bold',
          borderRadius: 8,
          textDecoration: 'none',
        }}
      >
        Go to Dashboard
      </Link>
    </div>
  );
}
